import AlphabetNavigation from './AlphabetNavigation.container';

export default AlphabetNavigation;
